import React,{useEffect,useState} from "react"
import {Modal,ModalHeader,ModalFooter,ModalBody} from "reactstrap"
import Api,{SERVER} from "./Api";
import _ from "lodash";
import { useGlobal } from "./Reducer";
const BACKGROUND="BACKGROUND";
const LOGO="LOGO";
const ARTICLE="ARTICLE";
const VIDEO="VIDEO"

export {LOGO,BACKGROUND,VIDEO,ARTICLE}


export default (props)=>{
    let type=props.type;
    let label="image";
    if(type==VIDEO)
    {
        label="video";
    }



    const [globalState,globalActions]=useGlobal();
    const [image,setImage]=useState(null);
    const [images,setImages]=useState([]);
    const [selectedImage,setSelectedImage]=useState(null);

    
    const deleteImage=(name)=>{
        globalActions.loading(true);
        Api.deleteFile(name,type).then(()=>{
            getImages();
        }).finally(()=>{
            globalActions.loading(false);
        });
    }

    const getImages=()=>{
        globalActions.loading(true);
        Api.getAllImages(type).then(images=>{
            setImages(images);
        }).catch(err=>{
         
        }).finally(()=>{
           globalActions.loading(false);
        })
    }

    const useThisImage=()=>{
        if(selectedImage==null)
        {
            globalActions.showAlert("select Image","Plase select Image to use");
            return;
        }
        props.withImage(selectedImage);
        props.onClose();
    }
    

    useEffect(()=>{
        getImages();
    },[])

    const doImageDelete=(name)=>{
        globalActions.showBooleanAlert("Sure?","Are you sure you want to delete "+name+"?",()=>{
            deleteImage(name);
        });
    }

    const upload=()=>{
     //   debugger;
        if(image==null)
        {
            alert("Select "+label,label+" is not selected");
            globalActions.showAlert("Select "+label,label+" is not selected")
            return;
        }
        if(type==BACKGROUND || type==LOGO || type==ARTICLE)
        {
            /**
             * @type {string}
             */
            
            let name=image.name.toLowerCase();
            name=name.substring(name.lastIndexOf(".")+1,name.length);
            if(["jpg","png","gif","jpeg"].indexOf(name)==-1)
            {
                globalActions.showAlert("Select "+label,"select valid format ")
                return null;
            }
        }
        if(type==VIDEO)
        {
        
            let name=image.name.toLowerCase();
            name=name.substring(name.lastIndexOf(".")+1,name.length);
            if(["mp4","mpeg","mov"].indexOf(name)==-1)
            {
                globalActions.showAlert("Select "+label,"select valid format ")
                return null;
            }
        }

        globalActions.loading(true);
        Api.uploadFile(image,props.type).then(()=>{
                setImage(null);
                getImages();
        }).catch(err=>{
            
        }).finally(()=>{
            globalActions.loading(false);
        })
    }
    let imageURL="";
    if(image!=null)
    {
        imageURL=URL.createObjectURL(image);
    }

    const doSelectImage=()=>{};


    return(<Modal isOpen={true} centered={true} size="xl">
            <ModalHeader>{type}</ModalHeader>
            <ModalBody>
                <div style={{overflow:"auto",maxHeight:400,margin:10}}>
                        <table className="table table-striped">
                            <thead> 
                                <tr>
                                <th>{label}</th>
                                <th>{label} name</th>
                                <th>Delete</th>
                                </tr>
                            </thead>
                                <tbody>
                                        {_.map(images,(image,index)=>{
                                            return (<tr key={image.name+index}>
                                                <td>
                                                   {type!=VIDEO && <div style={{cursor:"pointer"}}   onClick={()=>{
                                                     setSelectedImage(`${SERVER}${image.path}`);
                                                 }}>
  <img style={{maxHeight:100,maxWidth:100}}
                                              
                                              src={`${SERVER}${image.path}`} />

                                                 </div>}

                                                 {type==VIDEO && <div style={{cursor:"pointer"}}   onClick={()=>{
                                                     setSelectedImage(`${SERVER}${image.path}`);
                                                 }}>
  <video style={{maxHeight:100,maxWidth:100}} controls={true}
                                              
                                              src={`${SERVER}${image.path}`} />
                                              Select

                                                 </div>}
                                               
                                                </td>
                                                <td>{image.name}</td>
                                                <td><button onClick={()=>{
                                                    doImageDelete(image.name);
                                                }} className="btn btn-danger btn-sm">delete</button></td>        
                                            </tr>);
                                        })}
                                </tbody>
                        </table>

                </div>
                <div className="row">

                <div className="col-6">
                    <div style={{height:300}} className="card">
                        <div className="card-header">Selected {label}</div>
                        <div className="card-body">
                                   {type!=VIDEO &&  <img src={selectedImage} style={{maxHeight:200,maxWidth:200}} />     }
                                   {type==VIDEO &&  <video controls={true} src={selectedImage} style={{maxHeight:200,maxWidth:200}} />     }   

                        </div>
                        <div className="card-footer">
                            <button
                                onClick={useThisImage}
                            className="btn btn-success">Use this {label}</button>
                        </div>
                    </div>
                    </div>

                    <div className="col-6">
                <div style={{height:300}}  className="card ">
                        <div className="card-header">Upload {label}</div>
                    <div className="card-body">
                        
                            <div  style={{display:"flex"}}>
                                
                                <input onChange={e=>{
                                   setImage((e.target.files[0]));
                                }} type="file" />
                                 {type!=VIDEO && <img  style={{maxHeight:200,maxWidth:200,margin:5,border:1}} src={imageURL} />}
                                 {type==VIDEO && <video controls={true} style={{maxHeight:200,maxWidth:200,margin:5,border:1}} src={imageURL} />}
                              
                               
                            </div>
                    </div>
                    <div className="card-footer">
                               <button onClick={upload} className="btn btn-success">Upload</button>
                               </div>
                    </div>
                </div>
             
                </div>
                
            </ModalBody>
            <ModalFooter>
                <button onClick={props.onClose} className="btn btn-secondary">Close</button>
            </ModalFooter>
    </Modal>)



}

 